// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_mh-0";